import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import errorBoundary from '@ifeng-fe/errorBoundary';
import { Event } from '@ifeng-fe/ui_base';
import Slides from '@ifeng-fe/ui_pc_slides';

import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { handleAd } from '@ifeng-fe/container_channel/common/client/utils/handleAd';

import { formatImage } from '@ifeng-fe/container_channel/common/client/utils/formatImg';

class BottomSlide extends React.PureComponent {
    state = {
        data: [],
    };
    static propTypes = {
        content: PropTypes.array,
    };

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            console.log('insertArr', insertArr); // 要插入的数据的索引
            console.log('replaceArr', replaceArr); // 被替换的数据的索引
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        // 插入软广
        try {
            /* eslint-disable */
            const { ad } = this.props;

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
            /* eslint-enable */
        } catch (e) {
            console.error(e);
        }

        try {
            const data = this.props.content;

            if (data) {
                this.setState(
                    {
                        data,
                    },
                    () => {
                        this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    adInit = data => {
        try {
            this.event.trigger('init', { data }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        // console.log('TopSlide=',this.props)

        const { data } = this.state;

        const sliderTmpl = function sliderTmpl(item) {
            if (item.type === 'ad') {
                return <div className={styles.li} ref={item.ref} />;
            } else {
                return (
                    <div className={styles.li}>
                        <a href={item.url} target="_blank" rel={rel}>
                            <img src={formatImage(item.thumbnail, 876, 480)} alt={item.title} title={item.title} />
                        </a>
                    </div>
                );
            }
        };

        const sliderConfig = {
            arrows: 'hover',
            dots: true,
            dotsAction: 'hover',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 3000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 0,
            speed: 500,
            infinite: true,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl,
        };

        return (
            <div className={styles.sliderContainer}>
                <Slides content={data} config={sliderConfig} />
            </div>
        );
    }
}
export default errorBoundary(BottomSlide);
